<div class="breadcrumb-area">
    <h1>Reporte de CxC</h1>
    <div class="row w-100 justify-content-end align-content-end px-2">
		<div class="col-auto form-group">
			<label for="start" class="form-label">Fecha inicio:</label>
			<input type="date" name="start" id="start" [(ngModel)]="start"
				class="form-control" [disabled]="loading">
		</div>
		<div class="col-auto form-group">
			<label for="end" class="form-label">Fecha final:</label>
			<input type="date" name="end" id="end" [(ngModel)]="end" class="form-control" [disabled]="loading">
		</div>
		<div class="col-auto align-content-end form-group">
			<button class="btn btn-success" (click)="loadDashboard()" [disabled]="loading">
                <span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loading"></span>
                <i class="fa fa-filter" *ngIf="!loading"></i>
            </button>
		</div>
	</div>
</div>

<div class="container-fluid">
    <div id="superset_embedding_div_class" class="superset-container"></div>
</div>